const BRAND = 'Tempo Loop';

export const formatDocumentTitle = (pageTitle?: string) =>
  pageTitle ? `${pageTitle} · ${BRAND}` : BRAND;

type TitleMatch = { staticData?: { skipDocumentTitle?: boolean; topNav?: { title?: string } } };

// `HeadContent` reads `title` off each meta entry to hoist a `<title>` tag; the
// upstream React types narrow `meta` to `<meta>` element props, so we widen here.
type DocumentHeadMeta = { title: string };

/** The deepest route match that names a page, shared by the `<title>` and the sidebar title bar. */
export const resolvePageTitle = (matches: readonly TitleMatch[]): string | undefined =>
  matches
    .map((match) => match.staticData?.topNav?.title)
    .filter((title): title is string => Boolean(title))
    .at(-1);

export const resolveDocumentHead = (
  matches: readonly TitleMatch[],
): { meta: DocumentHeadMeta[] } => {
  if (matches.some((match) => match.staticData?.skipDocumentTitle)) {
    return { meta: [] };
  }

  return { meta: [{ title: formatDocumentTitle(resolvePageTitle(matches)) }] };
};
